module.exports = __webpack_public_path__ + "7e4be23b68071484a730a2a90cb4d782.pdf";